import React from 'react';

const logoUrl =
  'https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvcG5n/cb031a7724b5418947317fb28beca1c5.png';

function Logo() {
  return (
    <a className="brand" href="#top" aria-label="Key Future Skills home">
      <img
        className="brand-logo"
        src={logoUrl}
        alt="Key Future Skills"
      />
      <div className="brand-copy">
        <strong>Key Future Skills</strong>
        <small>Practical leadership tools</small>
      </div>
    </a>
  );
}

export default Logo;